// 共通のslick設定
export const commonSlickOptions = {
  variableWidth: true,
  slidesToScroll: 3,
  slidesToShow: 4,
  infinite: false,
  arrows: true,
  responsive: [{
    breakpoint: 1286,
    settings: {
      slidesToShow: 3,
    }
  }],
};

// 特集・ピックアップ 用のslick設定
export const pickupSlickOptions = {
  infinite: false,
  slidesToScroll: 3,
  slidesToShow: 8,
  responsive: [{
    breakpoint: 1286,
    settings: {
      slidesToShow: 7,
    }
  }],
};
